<template>
  
  <form class="address-form">

      <div class="panel__block">
        <h2>{{ setFormTitle }}</h2>
      </div>

      <div class="panel__block">

        <div class="address-wrap">

          <div class="address-form__cell">
            <TextInput 
              context="address" 
              type="text"
              :value="setFieldValue('line1')" 
              label="Line 1"
              id="line1"
              :field="setField('line1')">
            </TextInput>
          </div>

          <div class="address-form__cell">
            <TextInput 
              context="address" 
              type="text"
              :value="setFieldValue('line2')" 
              label="Line 2"
              id="line2"
              :field="setField('line2')">
            </TextInput>
          </div>

          <div class="address-form__cell">
            <TextInput 
              context="address" 
              type="text"
              :value="setFieldValue('line3')" 
              label="Line 3"
              id="line3"
              :field="setField('line3')">
            </TextInput>
          </div>

          <div class="address-form__cell cell-50">
            <TextInput 
              context="address" 
              type="text"
              :value="setFieldValue('city')" 
              label="City"
              id="city"
              :field="setField('city')">
            </TextInput>
          </div><!--

       --><div class="address-form__cell cell-25">
            <Dropdown 
              id="province" 
              label="Province" 
              proto="province"
              :field="setField('province')">  
            </Dropdown>
          </div><!--

       --><div class="address-form__cell cell-25">
            <TextInput 
              context="address" 
              type="text"
              :value="setFieldValue('postalcode')" 
              label="Postal Code"
              id="postalcode"
              :field="setField('postalcode')">
            </TextInput>
          </div><!--

       --><div class="address-form__cell cell-50">
            <Dropdown 
              id="country" 
              label="Country" 
              proto="country"
              :field="setField('country')">  
            </Dropdown>
          </div>          
                              
        </div>

      </div>

  </form>

</template>

<script>

import TextInput from './TextInput.vue';
import Dropdown  from './Dropdown.vue';
 
export default {


	components: {

		TextInput,
    Dropdown

	}, 

  /**
   * METHODS
   * -------
   * 
   * These are the methods that are available to the 
   * component.
   */
   
  methods : {  

    setField(field) {

      return this.$parent.$data.subpanel.field + '.' + field;

    },

    setFieldValue(field) {

      return this.$store.getters.getFieldData({ field: this.$parent.$data.subpanel.field + '.' + field });

    }

  },


  /**
   * COMPUTED
   * --------
   * 
   * These functions are used to return computed values, which
   * can be bound to certain portions of the component.
   */  

  computed: {

    setFormTitle() {

      var vars = this.$parent.getSubpanelData();
      return vars.title;

    }

  },

  props : [
  	
    'field',

  ],

  data() {

    return {

    }

  }

}

</script>

<style lang="scss">

  .address-form {

    padding: 2rem 0 4rem;
    margin-left: -1.5rem;

  }

  .address-form__cell {

    display: inline-block;
    width: 100%;
    padding-left: 1.5rem;

    &.cell-50 {

      width: 50%;

    }

    &.cell-25 {

      width: 25%;

    }

  }

</style>


// WEBPACK FOOTER //
// AddressForm.vue?57c94f1c